import type { ReviewableProduct } from '@iheartjane/menu';
import { REVIEW_PROMPT_MAX_PRODUCTS, ReviewPrompt } from '@iheartjane/menu';

import { ClientOnly } from '@jane/bloom/components/clientOnly';
import { trackClosedLeaveReviewPrompt } from '@jane/bloom/services/tracking/track';

import { useLeaveReview } from './leaveReviewProvider';

import styles from './leaveReviewPrompt.module.css';

/**
 * Products-to-review prompt: a popover under the account icon on desktop, a
 * bottom sheet on mobile. Picking a product opens the Leave Review modal and
 * dismisses the prompt.
 */
export const LeaveReviewPrompt = () => {
  const { dismissPrompt, openLeaveReview, promptProducts } = useLeaveReview();

  if (promptProducts.length === 0) return null;

  const handleReviewProduct = ({ id }: ReviewableProduct) => {
    const product = promptProducts.find((candidate) => candidate.id === id);
    if (!product) return;

    dismissPrompt();
    openLeaveReview({
      moreToReview: promptProducts,
      product,
      source: 'prompt',
    });
  };

  const handleDismiss = () => {
    trackClosedLeaveReviewPrompt(
      promptProducts.slice(0, REVIEW_PROMPT_MAX_PRODUCTS).map(({ id }) => id)
    );
    dismissPrompt();
  };

  return (
    <ClientOnly>
      {(isMobile) => {
        const prompt = (
          <ReviewPrompt
            isMobile={isMobile}
            onDismiss={handleDismiss}
            onReviewProduct={handleReviewProduct}
            open
            products={promptProducts}
          />
        );

        return isMobile ? (
          prompt
        ) : (
          <div className={styles['desktopPrompt']}>{prompt}</div>
        );
      }}
    </ClientOnly>
  );
};
